import { loadAnalytics } from 'modules/analytics';
import { setConsentGiven } from '../analytics/analytics';

const SERVICE_ID_SEGMENT = 'O97xcRJFR';

export const handleConsentDetails = async (shouldReload: boolean) => {
  try {
    const data = await window.__ucCmp.getConsentDetails();

    const isSegmentConsentGiven =
      !!data.services[SERVICE_ID_SEGMENT]?.consent?.given;

    setConsentGiven(isSegmentConsentGiven);

    if (isSegmentConsentGiven) {
      await loadAnalytics();
      window.__ucCmp.refreshScripts();
    } else if (shouldReload) {
      window.location.reload();
    }
  } catch (error) {
    console.error('Error handling consent details:', error);
  }
};

export const handleConsentEvent = (shuoldReload: boolean = false) => {
  handleConsentDetails(shuoldReload).catch(error =>
    console.error('Error handling consent event:', error)
  );
};

export const initializeConsentManager = () => {
  console.log('CMP initialized');
  handleConsentEvent();
  window.addEventListener('UC_CONSENT', () => handleConsentEvent(true));
};
